/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BootsInputs */

const en_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boots`)
};

const es_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Botas`)
};

const fr_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottes`)
};

const de_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stiefel`)
};

const ja_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブーツ`)
};

const zh_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`靴子`)
};

const ar_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحذية طويلة (بوت)`)
};

const id_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepatu Bot`)
};

const it_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stivali`)
};

const ru_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ботинки/Сапоги`)
};

const pt_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Botas`)
};

const ko_val_boots = /** @type {(inputs: Val_BootsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부츠`)
};

/**
* | output |
* | --- |
* | "Boots" |
*
* @param {Val_BootsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_boots = /** @type {((inputs?: Val_BootsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BootsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_boots(inputs)
	if (locale === "es") return es_val_boots(inputs)
	if (locale === "fr") return fr_val_boots(inputs)
	if (locale === "de") return de_val_boots(inputs)
	if (locale === "ja") return ja_val_boots(inputs)
	if (locale === "zh") return zh_val_boots(inputs)
	if (locale === "ar") return ar_val_boots(inputs)
	if (locale === "id") return id_val_boots(inputs)
	if (locale === "it") return it_val_boots(inputs)
	if (locale === "ru") return ru_val_boots(inputs)
	if (locale === "pt") return pt_val_boots(inputs)
	return ko_val_boots(inputs)
});